module.exports = __webpack_public_path__ + "img/CN.816d3a74.jpg";